export default __webpack_public_path__ + "static/forming-hero-5a3cc0888e4e4a47de07dda258d5db45.jpg";